import {
  Button,
  CloseButton,
  Dialog,
  Modal,
  ModalOverlay,
} from "@light-technology/components";
import type { ReactNode } from "react";

type BasicModalProps = {
  textTitle: string;
  textDescription: string;
  textCancel: string;
  textSubmit: string;
  isDisabled: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  isDestructive?: boolean;
  iconSubmit?: ReactNode;
  iconSubmitOnClick?: ReactNode;
  children?: ReactNode | ReactNode[];
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  "data-ph-capture-attribute-action"?: string;
};

export const BasicModal = (props: BasicModalProps) => {
  return (
    <ModalOverlay
      isDismissable
      isOpen={props.isOpen}
      onOpenChange={props.onOpenChange}
    >
      <Modal>
        <Dialog aria-label={props.textTitle}>
          <div className="relative w-full max-w-100 rounded-2xl bg-primary p-3xl">
            <CloseButton
              className="absolute top-4 right-2 z-0"
              size="lg"
              onClick={props.onCancel}
            />
            <div className="pointer-events-none relative pr-4xl text-lg font-semibold">
              {props.textTitle}
            </div>
            <div className="mb-2xl pt-xs text-md text-tertiary">
              {props.textDescription}
            </div>
            {props.children}
            <div className="mt-4xl flex gap-lg">
              <Button
                className="flex-1"
                color="secondary"
                size="lg"
                onClick={props.onCancel}
              >
                {props.textCancel}
              </Button>
              <Button
                className="flex-1"
                color={props.isDestructive ? "primary-destructive" : "primary"}
                size="lg"
                iconLeading={props.iconSubmit}
                iconLeadingOnClick={props.iconSubmitOnClick}
                isDisabled={props.isDisabled}
                isLoading={props.isLoading}
                onClick={props.onSubmit}
                data-ph-capture-attribute-action={
                  props["data-ph-capture-attribute-action"]
                }
              >
                {props.textSubmit}
              </Button>
            </div>
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};
